import React from "react";
import { Button, Typography, Container, Grid, Paper, Box } from "@mui/material";
import { Link } from "react-router-dom";
import { Facebook, Instagram, LinkedIn, Twitter } from "@mui/icons-material";
import "./LandingPage.css";
import Newfooter from "../common/NewFooter";
import Landingimg1 from "../../Assets/Landing-img1.jpg";
import Landingimg2 from "../../Assets/Landing-img2.jpg";
import Landingimg3 from "../../Assets/Landing-img3.jpg";

import CompanyLogo from "../../Assets/infyulogo3.png";
const LandingPage = () => {
  return (
    <div className="landing-wrapper">
      <div className="logo-bar">
        <img src={CompanyLogo} alt="Company Logo" className="company-logo" />
      </div>

      <div className="hero-container">
        <Container>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <p className="hero-logo">
                <span className="logo-infy">InfyU</span>{" "}
                <span className="logo-hr">LABS</span>
              </p>

              <Typography variant="h4" className="hero-heading">
                Your one-stop solution for managing human resources efficiently.
              </Typography>
              <Typography variant="body1" className="hero-subtitle">
                Where People Management Meets People Care.
              </Typography>
            
              <Link to="/login" className="custom-login-button">
                Login Now
              </Link>
            </Grid>
            <Grid item xs={12} md={6}>
              <img src={Landingimg3} alt="Team" className="hero-image" />
            </Grid>
          </Grid>
        </Container>
      </div>

      <div className="about-section">
        <Container>
          <Grid container spacing={4} alignItems="flex-start">
            <Grid item xs={12} md={4}>
              <Typography variant="h5" className="about-title">
                About us
              </Typography>
              <p className="about-text">
                We are dedicated to the democratization of food testing with a
                mission to make chemical-free quality fruits accessible to
                everyone.
              </p>
            </Grid>

                     <Grid item xs={12} md={4}>
              <Paper className="blog-card">
                <img src={Landingimg2} alt="Blog 1" className="blog-image" />
                <Typography variant="subtitle1" className="blog-title">
                  Streamline HR Operations
                </Typography>
                <Typography variant="body2" className="blog-description">
                  Simplify complex HR processes with our intuitive platform.
                  From recruitment to retirement, everything is handled with
                  care.
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper className="blog-card">
                <img src={Landingimg1} alt="Blog 2" className="blog-image" />
                <Typography variant="subtitle1" className="blog-title">
                  Employee Self-Service
                </Typography>
                <Typography variant="body2" className="blog-description">
                  Empower your workforce by giving them easy access to their
                  profiles, documents, leave management, and more.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </div>

      <Newfooter />
    </div>
  );
};

export default LandingPage;
